import { useImageAnnotatorContext } from "@msuite/image-annotator";
import { DimensionAnnotation } from "./dimension-annotation";
import { DimensionAnnotationPreview } from "./dimension-annotation-preview";
import { PolygonAnnotation } from "./polygon-annotation";
import { PolygonAnnotationPreview } from "./polygon-annotation-preview";
import { TextAnnotation } from "./text-annotation";

export function Annotations() {
	/** Context */
	const context = useImageAnnotatorContext();

	/** Render */
	return (
		<g>
			{context.controller.annotations.map((annotation) => {
				if (annotation.type === "polygon") {
					return (
						<PolygonAnnotation
							key={annotation.id}
							annotation={annotation}
						/>
					);
				} else if (annotation.type === "dimension") {
					return (
						<DimensionAnnotation
							key={annotation.id}
							annotation={annotation}
						/>
					);
				} else if (annotation.type === "text") {
					return (
						<TextAnnotation
							key={annotation.id}
							annotation={annotation}
						/>
					);
				}
				return null;
			})}
			<PolygonAnnotationPreview />
			<DimensionAnnotationPreview />
		</g>
	);
}
